import { _request, APIBaseResponse, APIMethod } from '../';
import { RequestParamsBase } from '../Models/CommonRequestModels';

const TENANTS_PATH_PREFIX = '/tenants';
const ACL_ACCESSES_PATH_PREFIX = 'aclaccesses';

type APIAclAccessesGetParams = RequestParamsBase & {
    tenantId: string;
};

export type AclAccess = {
    tenantId: string;
    id: string;
    name: string;
}

type APIAclAccessesGetResponse = APIBaseResponse<Array<AclAccess>>;

export const APIAclAccessGetList: APIMethod<APIAclAccessesGetParams, APIAclAccessesGetResponse> = (params: APIAclAccessesGetParams) => (
    _request('GET', `${TENANTS_PATH_PREFIX}/${params.tenantId}/${ACL_ACCESSES_PATH_PREFIX}`, undefined, params.signal)
);

export type AclAccessPostProperties = {
    permissions: string[];
}

export type APIAclAccessPostParams = {
    name: string;
    properties: AclAccessPostProperties;
    tenantId: string;
};

export type APIAclAccessPostResponse = APIBaseResponse<{
    aclAccessId: string;
}>;

export type APIAclAccessPutParams = {
    id: string;
    name: string;
    properties: AclAccessPostProperties;
    tenantId: string;
};

export const APIAclAccessPost: APIMethod<APIAclAccessPostParams, APIAclAccessPostResponse> = (params) => (
    _request<APIAclAccessPostResponse>('POST', `${TENANTS_PATH_PREFIX}/${params.tenantId}/${ACL_ACCESSES_PATH_PREFIX}`, {
        name: params.name,
        tenantId: params.tenantId,
        properties: params.properties,
    })
);

type APIAclAccessDeleteParams = {
    aclAccessId: string;
    tenantId: string;
};

type APIAclAccessDeleteResponse = {
    error: string | null;
    success: boolean;
    data: null;
};

export const APIAclAccessDelete: APIMethod<APIAclAccessDeleteParams, APIAclAccessDeleteResponse> = (params) => (
    _request('DELETE', `${TENANTS_PATH_PREFIX}/${params.tenantId}/${ACL_ACCESSES_PATH_PREFIX}/${params.aclAccessId}`)
);

export const APIAclAccessPut: APIMethod<APIAclAccessPutParams, APIBaseResponse> = (params) => (
    _request<APIBaseResponse>('PUT', `${TENANTS_PATH_PREFIX}/${params.tenantId}/${ACL_ACCESSES_PATH_PREFIX}/${params.id}`, {
        id: params.id,
        name: params.name,
        tenantId: params.tenantId,
        properties: params.properties,
    })
);
